// extracted by mini-css-extract-plugin
export default {"input":"InviteUser_input__xRefJ","btnWrapper":"InviteUser_btnWrapper__MDgm0"};